import clsx from 'clsx';
import React from 'react';
import { useEffect } from 'react';

import {
  Modal,
  ModalContentProps,
  ModalActionsProps,
  ModalProps,
} from 'semantic-ui-react';

import POSIcon from '../POSIcon';
import './CustomModal.less';

export interface Props extends ModalProps {
  blackDimmer?: boolean;
}

export type CustomActionProps = ModalActionsProps;
const CustomModalActions = (props: CustomActionProps) => {
  return <Modal.Actions {...props} />;
};

export type CustomModalContentProps = ModalContentProps;
const CustomModalContent = (props: CustomModalContentProps) => {
  return <Modal.Content {...props} />;
};

const BLACK_DIMMER = 'black-dimmer';

export const CustomModal = (props: Props) => {
  const {
    children,
    header,
    closeIcon,
    centered,
    blackDimmer,
    ...allOtherProps
  } = props;

  useEffect(() => {
    if (!blackDimmer) return;

    if (allOtherProps.open) {
      document.body.classList.add(BLACK_DIMMER);
    } else {
      document.body.classList.remove(BLACK_DIMMER);
    }
  }, [blackDimmer, allOtherProps.open]);

  return (
    <Modal
      {...allOtherProps}
      className={clsx('p-os-custom-modal', allOtherProps.className)}
      closeIcon={closeIcon ?? <POSIcon icon="close" />}
      centered={centered ?? false}
    >
      <Modal.Header content={header as React.ReactNode} />
      {children}
    </Modal>
  );
};

CustomModal.Actions = CustomModalActions;
CustomModal.Content = CustomModalContent;
